export const cultures = [
  { id: "pomme_de_terre", name: "pomme_de_terre", label: "cultures.pomme_de_terre" },
  { id: "cereales", name: "cereales", label: "cultures.cereales" },
  { id: "tomate_industrielle", name: "tomate_industrielle", label: "cultures.tomate_industrielle" },
  { id: "tomate_plein_champ", name: "tomate_plein_champ", label: "cultures.tomate_plein_champ" },
  { id: "tomate_sous_serre", name: "tomate_sous_serre", label: "cultures.tomate_sous_serre" },
  { id: "arbres-fruitiers", name: "arbres-fruitiers", label: "cultures.arbres_fruitiers" },
  { id: "melon_pasteque", name: "melon_pasteque", label: "cultures.melon_pasteque" },
  { id: "autres_cucurbitacées", name: "autres_cucurbitacées", label: "cultures.autres_cucurbitacees" },
  { id: "mais", name: "mais", label: "cultures.mais" },
  { id: "oleagineuses", name: "oleagineuses", label: "cultures.oleagineuses" },
  { id: "agrumes", name: "agrumes", label: "cultures.agrumes" },
  { id: "vigne", name: "vigne", label: "cultures.vigne" },
  { id: "leguminueses", name: "leguminueses", label: "cultures.legumineuses" }
]